import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import NavigationLeftSelected from "@/icons/Navigation/Left/Selected";
import NavigationRightSelected from "@/icons/Navigation/Right/Selected";

import { Button } from "../Button";
import { Icon } from "../Icon";
import { A11yText } from "../A11yText";

import styles from "./SliderButton.scss";

export const SliderButton = ({
  variant,
  forwardText,
  backwardText,
  customClass,
  ...props
}) => {
  const backwards = variant === "backwards";
  const icon = backwards ? NavigationLeftSelected : NavigationRightSelected;
  const a11yText = backwards ? backwardText : forwardText;
  return (
    <Button
      variants={[
        cx(
          Button.Variant.slider,
          Button.Variant.icon,
          styles.button,
          customClass
        ),
      ]}
      {...props}
    >
      <span className={styles["icon-wrapper"]}>
        <Icon
          icon={icon}
          size={Icon.Size.medium}
          wrapperProps={{
            style: {
              width: "100%",
              position: "relative",
              left: backwards ? -1 : 1,
            },
          }}
        />
        <A11yText>{a11yText}</A11yText>
      </span>
    </Button>
  );
};

SliderButton.defaultProps = {
  variant: "forwards",
  forwardText: "Vor",
  backwardText: "Zurück",
  customClass: null,
};

SliderButton.propTypes = {
  variant: PropTypes.oneOf(["backwards", "forwards"]),
  forwardText: PropTypes.string,
  backwardText: PropTypes.string,
  customClass: PropTypes.string,
};

SliderButton.displayName = "SliderButton";

export default SliderButton;
